
    import QuestionMixin from '@/components/JobView/Apply/Questions/QuestionMixin';
    import C1Dropdown from '@/C1Components/C1Dropdown';
    import C1DropdownItem from '@/C1Components/C1DropdownItem';
    import { everyNowAndThen } from '@/utils/helpers';

    export default {
        name: 'QuestionAvailability',

        components: {
            C1Dropdown,
            C1DropdownItem,
        },

        mixins: [
            QuestionMixin,
        ],

        data() {
            return {
                is24x7: false,
                daysRange: [
                    { label: 'Sunday', short: 'S', start: '09:00am', finish: '05:00pm', is_active: false },
                    { label: 'Monday', short: 'M', start: '09:00am', finish: '05:00pm', is_active: true },
                    { label: 'Tuesday', short: 'T', start: '09:00am', finish: '05:00pm', is_active: true },
                    { label: 'Wednesday', short: 'W', start: '09:00am', finish: '05:00pm', is_active: true },
                    { label: 'Thursday', short: 'T', start: '09:00am', finish: '05:00pm', is_active: true },
                    { label: 'Friday', short: 'F', start: '09:00am', finish: '05:00pm', is_active: true },
                    { label: 'Saturday', short: 'S', start: '09:00am', finish: '05:00pm', is_active: true },
                ],
                timeRange: everyNowAndThen(60),
            };
        },

        computed: {
            daysRangeFiltered() {
                return this.daysRange.filter(o => o.is_active);
            },

            answer() {
                return this.daysRange
                    .filter(o => o.is_active)
                    .reduce((obj, item) => {
                        return {
                            ...obj,
                            [item.label.toLowerCase()]: [
                                {
                                    start: item.start,
                                    finish: item.finish,
                                },
                            ],
                        };
                    }, {});
            },
        },

        watch: {
            is24x7(value) {
                if (!value) { return; }
                this.daysRange.forEach((o) => { o.is_active = true; o.start = '00:00am'; o.finish = '00:00am'; });
            },
        },

        methods: {
            setStartTime(day, time) {
                day.start = time;
            },

            setFinishTime(day, time) {
                day.finish = time;
            },

            copyTime(start, finish) {
                this.daysRange.forEach((o) => {
                    o.start = start;
                    o.finish = finish;
                });
            },

            toggleDay(day) {
                day.is_active = !day.is_active;
            },
        },
    };
